import { render, staticRenderFns } from "./upgrade-popup-v2.vue?vue&type=template&id=d4e4f70e&scoped=true&lang=pug&"
import script from "./upgrade-popup-v2.vue?vue&type=script&lang=js&"
export * from "./upgrade-popup-v2.vue?vue&type=script&lang=js&"
import style0 from "./upgrade-popup-v2.vue?vue&type=style&index=0&id=d4e4f70e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e4f70e",
  null
  
)

export default component.exports